var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-wrapper',[_c('portal',{attrs:{"to":_vm.PortalTarget.SIDEBAR}},[_c('object-types-sidebar')],1),_c('CentralCosts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }